module.exports = __webpack_public_path__ + "static/scale-model-of-milwaukee-public-museum-in-milwaukee-wisconsin-f52c7d0fa7223a2c486b344171563b83.png";